
<template>
    <FormulateForm
        class="form form--login"
        @submit="attemptLogin"
        v-model="formFields"
    >
        <SVGlogo class="logo logo--lg hide--mob" />

        <Alert type="error" v-if="error">
            <!-- TODO: MAKE ERROR_SLIM COMPONENT & Capitalise error -->
            {{ error }}
        </Alert>

        <FormulateInput
            class="form__group"
            label="Email"
            type="email"
            name="email"
            validation="email"
        >
            <template #label="{ label, id }">
                <label :for="id">
                    {{ label }}<span class="form--required" aria-label="required">*</span>
                </label>
            </template>
        </FormulateInput>

        <FormulateInput
            class="form__group"
            label="Password"
            type="password"
            name="password"
            validation="required"
        >
            <template #label="{ label, id }">
                <label :for="id">
                    {{ label }}<span class="form--required" aria-label="required">*</span>
                </label>
            </template>
        </FormulateInput>

        <section class="form__sub-actions form__group--inline">
            <FormulateInput
                v-model="remember"
                class="not-bold"
                :options="{ remember: 'Remember Me' }"
                type="customCheckbox"
            />

            <a href="#" @click.prevent="$emit('toggleForgotPassword')">Forgot Password?</a>
        </section>

        <footer class="form__actions center">
            <FormulateInput
                :class="[
                    'btn--full',
                    { 'btn--loading' : loading }
                ]"
                :disabled="loading"
                type="submit"
                name="submit"
            >
                {{ btnLabel }} <Spinner v-if="loading" />
            </FormulateInput>

            <p>Not a member? <a href="#" @click.prevent="$emit('switchForm')">Sign Up</a></p>
        </footer>

    </FormulateForm>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            formFields: {},
            remember: false,
            error: null,
            loading: false,
        }
    },

    computed: {
        btnLabel () {
            if (this.loading) return 'Logging In...'
            return 'Log In'
        }
    },

    methods: {
        ...mapActions('Auth', ['loginUser']),

        attemptLogin () {
            const { email, password } = this.formFields
            const { redirectFrom } = this.$route.query

            this.loading = true
            this.error = null

            this.loginUser({ email, password, remember: this.remember })
                .then(() => {
                    if (redirectFrom) this.$router.push({ path: redirectFrom })
                    else this.$router.push({ name: 'dashboard' })
                })
                .catch(error => this.error = error.message || error)
                .finally(() => { this.loading = false })
        }
    },
}
</script>

